import React from 'react'
import RichTextEditor from '@/shared/RichTextEditor'

const TipTapWysiwyg = (props) => <RichTextEditor variant='document' {...props} />

export default TipTapWysiwyg
